import { useCallback } from 'react'
import { type RoleGetInput, type RoleGetSuccess, type RoleHolder, type RoleId } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { roleKey } from '../keys'
import { useServerRequest } from '../api'

export function useFetchRoleHolders(): (roleId: RoleId) => Promise<RoleHolder[]> {
  const serverRequest = useServerRequest<RoleGetInput, RoleGetSuccess>('/role/get')
  const queryClient = useQueryClient()
  return useCallback(
    async (roleId: RoleId): Promise<RoleHolder[]> => {
      const { holders = [] } = await queryClient.fetchQuery({
        queryKey: roleKey(roleId, { includeHolders: true }),
        staleTime: 0,
        queryFn: () => serverRequest({ roleId, includeHolders: true }),
      })
      return holders
    },
    [queryClient, serverRequest]
  )
}
